import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "María Fernández",
    place: "Familia fundadora",
    text: "Cruzar la entrada de Pextlán es como entrar a otro mundo. Los niños no quieren irse y nosotros tampoco. Es nuestro pedazo de paz.",
    image: "https://images.pexels.com/photos/27175654/pexels-photo-27175654.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Familia Torres",
    place: "Apartaron en preventa",
    text: "Buscábamos algo distinto a un fraccionamiento típico. Aquí los lotes respiran, no hay vallas, hay arroyo. Vale cada peso.",
    image: "https://images.pexels.com/photos/29718642/pexels-photo-29718642.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    name: "Jorge Hernández",
    place: "Inversionista",
    text: "Plusvalía real con propósito ecológico. La cercanía con Xico y los Cañones de Pextlán es un imán turístico que multiplicará el valor.",
    image: "https://images.pexels.com/photos/27175654/pexels-photo-27175654.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

export default function Testimonials({ content = {} }) {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative py-28 bg-[#0B1A0F] overflow-hidden"
    >
      <div className="orb w-[400px] h-[400px] bg-[#F1C36B]/20 -top-32 right-1/4" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl text-center mx-auto">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] font-medium text-[#F1C36B]">
            <Quote className="w-4 h-4" /> {content.testimonials_overline || "Voces del bosque"}
          </span>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl text-[#F2EFE6] leading-[1.05]">
            {content.testimonials_title_1 || "Lo que dicen quienes ya"}{" "}
            <span className="font-fairy text-[#B8E07A]">{content.testimonials_title_fairy || "cruzaron el portal"}</span>
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-7" style={{ perspective: "1200px" }}>
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 50, rotateX: 12 }}
              whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
              whileHover={{ y: -6, rotateY: 4, scale: 1.02 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              data-testid={`testimonial-${i}`}
              className="relative rounded-3xl bg-gradient-to-br from-[#15301E] to-[#0B1A0F] border border-[#B8E07A]/15 p-7 shadow-[0_25px_60px_-25px_rgba(0,0,0,0.7)]"
              style={{ transformStyle: "preserve-3d" }}
            >
              <Quote className="w-9 h-9 text-[#F1C36B]/70" />
              <blockquote className="mt-4 text-[#F2EFE6]/85 leading-relaxed text-[15px]">
                "{t.text}"
              </blockquote>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-dashed border-[#B8E07A]/15">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover ring-2 ring-[#F1C36B]/40"
                />
                <div className="flex-1">
                  <div className="font-serif text-lg text-[#F2EFE6] leading-tight">
                    {t.name}
                  </div>
                  <div className="text-[11px] uppercase tracking-widest text-[#B8E07A]">
                    {t.place}
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="w-3.5 h-3.5 fill-[#F1C36B] text-[#F1C36B]" />
                  ))}
                </div>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
